/**
 * Note editor events — image annotations, blocks, tables and diagrams.
 *
 * One slice of the `ANALYTICS_EVENTS` SSOT — see `../analytics.ts`, which
 * spreads every slice back into the single import surface call sites use.
 * The event NAME STRINGS are a PostHog dashboard contract: add and retire keys
 * here, never rename a value in place (see `rules/analytics.md`).
 */

export const EDITOR_EVENTS = {
  // Image Annotations
  IMAGE_ANNOTATION_STARTED: 'Image Annotation Started',
  IMAGE_ANNOTATION_SAVED: 'Image Annotation Saved',
  IMAGE_ANNOTATION_EXPORTED: 'Image Annotation Exported',
  INLINE_IMAGE_ANNOTATION_SAVED: 'Inline Image Annotation Saved',
  IMAGE_LIGHTBOX_OPENED: 'Image Lightbox Opened',

  // Editor Blocks
  EDITOR_BLOCK_INSERTED: 'Editor Block Inserted',
  EDITOR_TABLE_INTERACTED: 'Editor Table Interacted',
  /**
   * A note table's alternating row shading was turned on or off.
   *
   * Distinct from EDITOR_TABLE_INTERACTED, which fires once per editor mount
   * as a coarse "this note has tables someone touched" signal and cannot tell
   * one table action from another. This is the adoption signal for the first
   * table STYLE Bower offers, so it needs its own event.
   *
   * Properties: enabled — true when switching banding on, false when off.
   */
  EDITOR_TABLE_BANDED_ROWS_TOGGLED: 'Editor Table Banded Rows Toggled',

  /**
   * A note's page width was switched between the reading column and full
   * width. Saved on the note, so every viewer sees it.
   *
   * Properties: width ('default' | 'full', the NEW width); surface
   * ('action_row'; older events also carry 'menu', the ⋮ row removed in
   * 2026-10); artifact_type ('note' | 'protocol').
   */
  NOTE_WIDTH_TOGGLED: 'Note Width Toggled',

  // Diagrams
  DIAGRAM_CREATED: 'Diagram Created',
  DIAGRAM_SAVED: 'Diagram Saved',
  DIAGRAM_EDITED: 'Diagram Edited',
} as const;
